<ion-icon [name]="icon" size="large" [color]="color"></ion-icon>
